export const DateFormat: Record<string, Intl.DateTimeFormatOptions> = {
    full: {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
    },
};
